var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wholeContext"},[_c('app-sidebar'),_c('app-header',{attrs:{"transDataSet":_vm.transDate}}),_vm._m(0),(_vm.checkPopup)?_c('add-popup',{attrs:{"popupSet":_vm.popupSet}}):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appContext"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"area_wrap"})])])
}]

export { render, staticRenderFns }